/**
 * 新版官网站内链接解析
 * ---------------------------------------------------------------
 * 官网 6 个页面（首页/关于/产品/工厂/品控/新闻）均已移植为 vancheen-pc
 * 内部路由，站内链接直接透传给 router-link：
 *   - '/'           → 新版首页
 *   - '/about'      → 关于我们
 *   - '/products…'  → 产品中心（支持 ?cat= 系列）
 *   - '/factory'    → 工厂参观
 *   - '/quality'    → 品质控制
 *   - '/news'       → 新闻资讯
 * 未知路径仍渲染为占位链接，避免跳到空白路由。
 */
const KNOWN_PATHS = ['/', '/home', '/about', '/products', '/factory', '/quality', '/news', '/topProduct']

export function resolveNewHomeLink(to) {
  if (!to) return { kind: 'none' }
  if (typeof to !== 'string') return { kind: 'route', to }
  const path = to.split('?')[0]
  if (KNOWN_PATHS.indexOf(path) > -1) return { kind: 'route', to }
  return { kind: 'none' }
}

export default resolveNewHomeLink
